import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const transferAppTE = <E = CF.API.ApiError>(
  { userId, appId, body }: { userId: string; appId: string; body: { new_owner_id: string } },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.BaseResponse> =>
  fetchTE<CF.API.BaseResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps/${appId}/owner`,
      method: 'PATCH',
      body,
    },
    onRejected,
  );
